<template>
  <v-navigation-drawer v-model="toggle" app>
    <div class="user-info">
      <div class="image">
        <img src="@/assets/images/user.png" width="48" height="48" alt="User"/>
      </div>
      <div class="info-container  pt-3">
        <div class="email">{{nameSub}}</div>
        <div class="email"> depto: {{departamento}}</div>
        <!--<div class="name" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span> {{userName}}</span>
        </div>
        -->
      </div>
    </div>

    <v-list>
      <v-list-item @click="menu('home')">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle>Inicio</v-list-item-subtitle>
      </v-list-item>

      <span v-for="(item, index) in menuGral" :key="index">
        <v-list-item v-if="!item.group" :class="item.hidden" @click="menu(item.action)">
          <v-list-item-icon>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-subtitle>{{item.title}}</v-list-item-subtitle>
        </v-list-item>

        <v-list-group v-else no-action  :prepend-icon="item.icon" :class="item.hidden" dense>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-subtitle>{{item.title}}</v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <span v-for="(i, j) in item.items" :key="j">
            <v-list-item v-if="!i.group" link dense :class="`${i.hidden}`" @click="menu(i.action)">
                <v-list-item-icon>
                  <v-icon>{{i.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-subtitle dense>{{i.title}}</v-list-item-subtitle>
            </v-list-item>

            <v-list-group v-else no-action sub-group :class="i.hidden">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-subtitle>{{i.title}}</v-list-item-subtitle>
                </v-list-item-content>
              </template>

              <v-list-item v-for="(sub, k) in i.items" :key="k" link dense :class="sub.hidden" @click="menu(sub.action)">
                <v-list-item-subtitle dense>{{sub.title}}</v-list-item-subtitle>
                <v-list-item-icon>
                  <v-icon>{{sub.icon}}</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-group>

          </span>

        </v-list-group>
      </span>
      <!--
      <v-list-item @click="menu('MeAyuSolicitudes')">
        <v-list-item-icon>
          <v-icon>mdi-animation</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Mesa de Ayuda</v-list-item-title>
      </v-list-item>

      <v-list-item link @click="menu('MeAyuCalendar')">
        <v-list-item-icon>
          <v-icon>mdi-calendar</v-icon>
        </v-list-item-icon>
        <v-list-item-title dense>Calendario</v-list-item-title>
      </v-list-item>

      <v-list-item link @click="menu('MeAyuServicio')">
        <v-list-item-icon>
          <v-icon>mdi-account-multiple-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title dense>Atenciones</v-list-item-title>
      </v-list-item>

      <v-list-item link @click="menu('InvEquiposServicio')">
        <v-list-item-icon>
          <v-icon>mdi-desktop-mac</v-icon>
        </v-list-item-icon>
        <v-list-item-title dense>Servicios Equipos</v-list-item-title>
      </v-list-item>
      -->

      <!--
      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Mesa de Ayuda</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link dense  @click="menu('MeAyuSolicitudes')">
          <v-list-item-subtitle dense>Solicitudes</v-list-item-subtitle>
          <v-list-item-icon>
            <v-icon>mdi-animation </v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item link dense  @click="menu('MeAyuCalendar')">
          <v-list-item-subtitle dense>Calendario</v-list-item-subtitle>
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
      -->

      <!--
      <v-list-group no-action sub-group>
        <template v-slot:activator>
          <v-list-item-content>
              <v-list-item-title>
                <v-icon>mdi-book-multiple</v-icon> Catalogos
              </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link dense  @click="menu('InvProveedores')">
          <v-list-item-title dense>Proveedores</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
        </v-list-item>

      </v-list-group>
      -->

      <v-divider/>
      <!--
      <v-list-item link @click="menu('InvInsumos')">
        <v-list-item-title dense>Insumos</v-list-item-title>
        <v-list-item-icon>
          <v-icon>mdi-desktop-mac</v-icon>
        </v-list-item-icon>
      </v-list-item>
      -->

      <!--
      <v-list-item link dense  @click="menu('InvInsumoAlmacen')">
        <v-list-item-title dense>Almacen</v-list-item-title>
        <v-list-item-icon>
          <v-icon>mdi-contrast-box</v-icon>
        </v-list-item-icon>
      </v-list-item>
      -->

      <!--
      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>CATALOGOS</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link dense  @click="menu('ViewEmpleados')">
          <v-list-item-title dense>Empleados</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item link dense  @click="menu('ViewUsuarios')">
          <v-list-item-title dense>Usuarios</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item link dense  @click="menu('ViewRols')">
          <v-list-item-title dense>Roles</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item link dense  @click="menu('ViewPermisos')">
          <v-list-item-title dense>Permisos</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item link dense  @click="menu('departamentos')">
          <v-list-item-title dense>Departamentos</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-icon>
        </v-list-item>

      </v-list-group>
      -->

      <!--
      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Configuraciones</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link dense  @click="menu('ViewProcesos')">
          <v-list-item-title dense>Procesos</v-list-item-title>
          <v-list-item-icon>
            <v-icon>mdi-package-variant-closed</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
      -->

      <!--
      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Ejemplos</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item @click="menu('video')">
          <v-list-item-subtitle>Form Ejemplo</v-list-item-subtitle>
        </v-list-item>
        <v-list-item @click="menu('table')">
          <v-list-item-subtitle>Table Ejemplo</v-list-item-subtitle>
        </v-list-item>
        <v-list-item @click="menu('importador')">
          <v-list-item-subtitle>Importador Ejemplo</v-list-item-subtitle>
        </v-list-item>
        <v-list-item @click="menu('menu')">
          <v-list-item-subtitle>Menu Dinamico</v-list-item-subtitle>
        </v-list-item>
      </v-list-group>
      -->

      <v-list-item @click="menu('logout')">
        <v-list-item-action>
          <v-icon class="blanco">mdi-logout</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="blanco">Cerrar Sesion</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-navigation-drawer>
</template>
<!-- ,default: false, required: false -->
<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
export default {
  props: {
    toggle: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    userName: '',
    nameSub: '',
    departamento: '',
    clipped: false,
    permisos: null,
    permisosUser: false,
    multiple: true,
    focusable: true,
    menuGral: [
      {
        id: 'ma.list',
        action: 'MeAyuSolicitudes',
        icon: 'mdi-animation',
        title: 'Mesa de Ayuda',
        group: false,
        hidden: 'hiddenItem'
      },
      {
        id: 'ma.list-calendar',
        action: 'MeAyuCalendar',
        icon: 'mdi-calendar',
        title: 'Calendario',
        group: false,
        hidden: 'hiddenItem'
      },
      {
        id: 'inventarios.by-status',
        action: 'InvInsumoAlmacen',
        icon: 'mdi-contrast-box',
        title: 'Almacen Insumos',
        group: false,
        hidden: 'hiddenItem'
      },

      {
        id: 'empresa.catalogo',
        icon: 'mdi-book-multiple',
        group: true,
        title: 'Catalogos',
        hidden: 'hiddenItem',
        items: [
          {
            id: 'empresa.catalogo.accesos',
            group: true,
            title: 'Accesos',
            hidden: 'hiddenItem',
            items: [
              {
                id: 'empresa.usuarios',
                action: 'ViewUsuarios',
                icon: 'mdi-account-circle',
                title: 'Usuarios',
                hidden: 'hiddenItem'
              },
              {
                id: 'empresa.roles-list',
                action: 'ViewRols',
                icon: 'mdi-account-network',
                title: 'Roles',
                hidden: 'hiddenItem'
              },
              {
                id: 'empresa.permisos-list',
                action: 'ViewPermisos',
                icon: 'mdi-key',
                title: 'Permisos',
                hidden: 'hiddenItem'
              }
            ]
          },
          {
            id: 'empresa.catalogo.inventarios',
            group: true,
            title: 'Inventarios',
            hidden: 'hiddenItem',
            items: [
              {
                id: 'inventario.insumos-list',
                action: 'InvInsumos',
                icon: 'mdi-desktop-mac',
                title: 'Inventario Insumos',
                group: false,
                hidden: 'hiddenItem'
              },
              {
                id: 'inventario.equipos-list',
                action: 'InvEquipos',
                icon: 'mdi-desktop-mac',
                title: 'Inventario Equipos',
                group: false,
                hidden: 'hiddenItem'
              }
            ]
          },

          {
            id: 'inventario.caracteristicas.list',
            action: 'InvCaracteristicas',
            icon: 'mdi-cogs',
            title: 'Caracteristicas',
            group: false,
            hidden: 'hiddenItem'
          },
          {
            id: 'td.list',
            action: 'InvTipoDato',
            icon: 'mdi-code-json',
            title: 'Tipo de Dato',
            group: false,
            hidden: 'hiddenItem'
          },

          {
            id: 'empresa.departamentos',
            action: 'departamentos',
            icon: 'mdi-lan',
            title: 'Departamentos',
            hidden: 'hiddenItem'
          },
          {
            id: 'empresa.empleados',
            action: 'ViewEmpleados',
            icon: 'mdi-account',
            title: 'Empleados',
            hidden: 'hiddenItem'
          },
          {
            id: 'inventario.familias.list',
            action: 'InvFamilia',
            icon: 'mdi-animation',
            title: 'Familias',
            group: false,
            hidden: 'hiddenItem'
          },
          {
            id: 'inventario.marcas.list',
            action: 'InvMarcas',
            icon: 'mdi-desktop-mac',
            title: 'Marcas',
            group: false,
            hidden: 'hiddenItem'
          },
          {
            id: 'inventario.procedencia.list',
            action: 'InvProcedencias',
            icon: 'mdi-ballot',
            title: 'Procedencias',
            group: false,
            hidden: 'hiddenItem'
          }
        ]
      },

      {
        id: 'empresa.configuraciones',
        icon: 'mdi-cogs',
        group: true,
        title: 'Configuraciones',
        hidden: 'hiddenItem',
        items: [
          {
            id: 'inventario.test-email',
            action: 'InvTestEmial',
            icon: 'mdi-email',
            title: 'Envio de correo Prueba',
            group: false,
            hidden: 'hiddenItem'
          },
          {
            id: 'inventario.importador',
            action: 'InvImportador',
            icon: 'mdi-database-import',
            title: 'Importador',
            group: false,
            hidden: 'hiddenItem'
          },
          {
            id: 'tipo-proceso.procesos-list',
            action: 'ViewProcesos',
            icon: 'mdi-package-variant-closed',
            title: 'Notificaciones',
            hidden: 'hiddenItem'
          }
        ]
      }
    ]
  }),
  mounted () {
    this.PermisosMenu(JSON.parse(localStorage.getItem('permisos')))
    this.setDataUser()
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlPostServiceLogoutAction']),
    setDataUser () {
      const user = this.$cookies.get('user')
      this.userName = user.usuario
      this.nameSub = user.NombreCompleto
      this.departamento = user.departamento
    },
    menu (item) {
      if (item != null) {
        if (item === 'logout') {
          this.$swal
            .fire({
              title: '¿Desea cerrar su session ?',
              text: 'Asegurese de haber concluido sus labores diarias',
              icon: 'warning',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Cerrar sesion',
              cancelButtonText: 'Cancelar'
            })
            .then(result => {
              if (result.value) {
                this.getUrl('usuario.logout')
              }
            })
        } else {
          router.push({ name: item })
        }
      }
    },
    PermisosMenu (user) {
      if (user.descripcion.special === 'all-access') {
        this.menuGral.map(action => {
          if (action.group) {
            action.hidden = ''
            action.items.map(subItems => {
              if (subItems.group) {
                subItems.hidden = ''
                subItems.items.map(subsubItems => {
                  subsubItems.hidden = ''
                })
              } else {
                subItems.hidden = ''
              }
            })
          } else {
            action.hidden = ''
          }
        })
        return
      }
      this.menuGral.map(action => {
        user.permisos.map(item => {
          if (action.group) {
            if (item.slug === action.id) {
              action.hidden = ''
              action.items.map(subItems => {
                user.permisos.map(per => {
                  if (subItems.group) {
                    if (per.slug === subItems.id) {
                      subItems.hidden = ''
                      subItems.items.map(subsubItems => {
                        user.permisos.map(persub => {
                          if (persub.slug === subsubItems.id) {
                            subsubItems.hidden = ''
                          }
                        })
                      })
                    }
                  } else {
                    if (per.slug === subItems.id) {
                      subItems.hidden = ''
                    }
                  }
                })
              })
            }
            // action para los sub menu
          } else {
            if (item.slug === action.id) {
              action.hidden = ''
            }
          }
        })
      })
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.urlPostServiceLogoutAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectAccess'])
  },
  watch: {
    get_objectAccess (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$cookies.remove('user')
      this.$cookies.remove('token')
      localStorage.clear()
      router.push('/')
    }
  }
}
</script>

<style>
.user-info {
  padding: 13px 15px 12px 15px;
  white-space: nowrap;
  position: relative;
  border-bottom: 1px solid #e9e9e9;
  background: url("../../assets/images/horizontal.jpg") no-repeat no-repeat;
  height: 135px;
}
.user-info .image {
  margin-right: 12px;
  display: inline-block;
}
.user-info .image img {
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  border-radius: 50%;
  vertical-align: bottom !important;
}
.user-info .info-container .name {
  white-space: nowrap;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  max-width: 200px;
  color: #fff;
}
.user-info .info-container .email {
  white-space: nowrap;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  max-width: 200px;
  color: #fff;
}
.hiddenItem{
  display: none;
}
</style>
